import React from 'react';
import { about5, heroVideo, arashBg, aboutBg, partnersBg } from '../../assets/images';
import Header from '../../Components/Header/Header';
import PartnersItems from './PartnersItems/PartnersItems';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';

const Partners = () => {

   const { t, i18n } = useTranslation();

  return (
    <>
        <Breadcrumb title={t("Tərəfdaşlıq")}/>

      <PartnersItems/>
    </>
  );
};

export default Partners;
